import { toast } from '@/helpers/toast/toast.helper'
import { updateOnFirebase } from '@/redux/chat/sagas/_http/user'
import { t } from 'i18next'
import { put } from 'redux-saga/effects'
import { connectSocket } from '@/helpers/socket'
import { signInAsync, verifyTwoFactorAsync } from '../../actions'
import { UserAuthenticated } from '../../types'
import { api } from '@/services/api'
import { OwnerSignInUser } from '../signInSaga'

export function* verifyTwoFactorSaga(action: ReturnType<typeof verifyTwoFactorAsync.request>) {
  try {
    const { preAuthTicket, code, companyId, navigate } = action.payload

    const response: { data: { user: OwnerSignInUser } } = yield api.post('/sign-in-owner/2fa/complete', {
      preAuthTicket,
      code
    })
    const ownerData = response.data.user

    const userAuthenticated: Partial<UserAuthenticated> = {
      id: ownerData.id,
      name: ownerData.name,
      email: ownerData.email,
      companies: ownerData.companies,
      ownerId: ownerData.ownerId,
      isWork: true,
      attendCampaigns: [],
      departments: [],
      token: ownerData.token,
      accessToken: ownerData.accessToken,
      isAdmin: ownerData.isAdmin
    }

    localStorage.setItem('devchat_app_userAuthenticated', JSON.stringify(userAuthenticated))
    connectSocket()

    try {
      yield updateOnFirebase(ownerData.id, { isWork: true })
    } catch (e) {
      console.warn('updateOnFirebase failed (non-critical):', e)
    }

    yield put(verifyTwoFactorAsync.success({ userAuthenticated: userAuthenticated as any }))
    yield put(signInAsync.success({ userAuthenticated: userAuthenticated as any }))
    yield navigate(`/select-campaign${companyId ? `?companyId=${encodeURIComponent(companyId)}` : ''}`)
  } catch (error) {
    const message = error.response?.data?.message || error.message

    const errorMessages: Record<string, string> = {
      invalid_or_expired_ticket: 'Sessão de 2FA expirada. Faça login novamente.',
      user_not_found: 'Usuário ou senha incorretos.',
      invalid_code: 'Código inválido. Tente novamente.'
    }

    yield toast({
      type: 'error',
      message: errorMessages[message] || t('translation:somethingWentWrong')
    })
    yield put(verifyTwoFactorAsync.failure({ message }))
  }
}
